import React from "react";
import { Markdown } from 'react-showdown';
import DocumentationType from '../components/Type';
import { Source, Example } from '../components/Others';

export default function Func({ docs }) {
    return <>
        <h1>
            {docs.name} <Source sources={docs.sources}/>
        </h1>

        <Markdown markdown={docs.comment.shortText || 'No documentation found.'}/>
        <Example comment={docs.comment}/>
        <hr style={{ marginTop: '15px'}}/>
        <h2 style={{ marginBottom: '10px' }}>Returns: </h2>
        <DocumentationType type={docs.returns}/>

        <h2 style={{ marginBottom: '10px' }}>Parameters: </h2>

        <table>
            <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Description</th>
            </tr>
            {docs.params.map(x => <tr>
                <td>{x.name}</td>
                <td><DocumentationType type={x.type}/></td>
                <td>{x.comment.shortText} {x.flags.isOptional ? <div className="badge">OPTIONAL</div> : null}</td>
            </tr>)}
        </table>
    </>
}